import firebase from 'firebase';
import { AppDispatch } from '../../store';
import { serializeMenuItemSnap } from '../menu/menu.service';
import { menuItemUpdated, menuItemListenerError, menuItemCookingIngredientsUpdated, resetMenuItem } from './menuItem.slice';
import { FirestoreHelper } from '../../helpers/firestoreHelper';
import { serializeCookingIngredientSnap } from './menuItem.service';

let unsubscribeMenuItem: firebase.Unsubscribe | null = null;
let activeMenuItemPath: string | null = null;

export const syncMenuItemListener = (
  menuItemPath: string | null,
  dispatch: AppDispatch
) => {
  if (menuItemPath === activeMenuItemPath) return;

  if (unsubscribeMenuItem) { unsubscribeMenuItem(); unsubscribeMenuItem = null; }

  activeMenuItemPath = menuItemPath;

  if (!menuItemPath) {
    dispatch(resetMenuItem());
    return;
  }

  unsubscribeMenuItem = firebase.firestore()
    .doc(menuItemPath)
    .onSnapshot(
      async (snapshot) => {
        if (!snapshot.exists) return;
        dispatch(menuItemUpdated(serializeMenuItemSnap(snapshot)));
        const cookingIngredientsSnap = await FirestoreHelper.cookingIngredientsForMenuItem(snapshot.ref);
        dispatch(menuItemCookingIngredientsUpdated({
          cookingIngredients: cookingIngredientsSnap.map(serializeCookingIngredientSnap),
          menuItemPath,
        }));
      },
      (error) => {
        dispatch(menuItemListenerError(error.message));
        activeMenuItemPath = null;
        unsubscribeMenuItem = null;
      }
    );
};